module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAtBAMAAAD8TT61AAAAAXNSR0IB2cksfwAAACRQTFRFAAAAADVVADZUADNTADVUADVUADZVADVVADRUADhYADVUADRUJ7wqcgAAAAx0Uk5TAFeAKK7/UWB/IMBAtB6K3gAAAD9JREFUeJxjYMAChJRAwACbFINrKAgkjMqNeLmKDhCYgFVuKVhkwxCUQ/gKUw4hMio3WOWKwGUXKP4QLGh5BgABoOFfaBiLlAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--analytics@2x.png
// module id = 920
// module chunks = 0